"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorLog = void 0;
var zod_1 = require("zod");
var FailedDatabaseQueryLog_1 = __importDefault(require("./error-log-types/FailedDatabaseQueryLog"));
var MoreThanOneContactErrorLog_1 = __importDefault(require("./error-log-types/MoreThanOneContactErrorLog"));
var UnknownErrorLog_1 = __importDefault(require("./error-log-types/UnknownErrorLog"));
var FileOperationErrorLog_1 = require("./error-log-types/FileOperationErrorLog");
var ErrorLog;
(function (ErrorLog) {
    ErrorLog.Schema = zod_1.z.union([
        MoreThanOneContactErrorLog_1.default.Schema,
        UnknownErrorLog_1.default.Schema,
        FailedDatabaseQueryLog_1.default.Schema,
        FileOperationErrorLog_1.FileOperationErrorLog.Schema,
    ]);
})(ErrorLog || (ErrorLog = {}));
exports.ErrorLog = ErrorLog;
